module.exports = __webpack_public_path__ + "fonts/bariol_regular-webfont.ef78052b.woff";